import type { ComponentProps, ForwardedRef, JSX } from 'react';

import { Image, ThemeProvider } from '@change/ds-core-ui/next';

import { forwardRef } from '@change-corgi/core/react/core';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { usePetitionQRCode } from 'src/app/shared/hooks/qrcode';

const TRANSPARENT_PNG =
	'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMBAAzjNdgAAAAASUVORK5CYII=';

type ImageProps = ComponentProps<typeof Image>;
type QRCodeProps = { slugOrId: string; size: number; type: QrCodeType } & ImageProps;

function PetitionQRCodeInner(
	{ slugOrId, size, type, ...rest }: QRCodeProps,
	ref: ForwardedRef<HTMLImageElement>,
): JSX.Element {
	const { data } = usePetitionQRCode({
		slugOrId,
		size,
		type,
		adjustForPixelRatio: true,
	});

	return (
		<ThemeProvider>
			<Image
				src={data?.imageBase64Uri || TRANSPARENT_PNG}
				width={size}
				alt="Petition QR Code"
				aspectRatio="1:1"
				className={`size-[${size}px] min-h-[${size}px] min-w-[${size}px]`}
				{...rest}
				ref={ref}
			/>
		</ThemeProvider>
	);
}

export const PetitionQRCode = forwardRef(PetitionQRCodeInner);
